import loader from '../moduleLoader.js';
import Overlay from '../Overlay/Overlay.js';
import Map from '../GoogleMaps/Map.js';

class MapOverlay {
    constructor(toggleButton) {
        this.toggleButton = toggleButton;
        this.overlay = null;
        this.map = null;
    }
    init() {
        this.toggleButton.addEventListener('click', this.toggleMap.bind(this));
    }
    toggleMap(e) {
        e.preventDefault();
        let overlay = document.getElementById('Overlay');
        if(!overlay) {
            window.dispatchEvent(new CustomEvent('MapOpened'));
            this.loadMap(function(mapHtml) {
                this.overlay = new Overlay(mapHtml, { cssClass:'overlay--bg'});
                this.overlay.open().then(overlay => {
                    loader.parseDom(overlay);
                    var innerCloseBtn = document.getElementById('map-inner-close-btn');
                    if (innerCloseBtn != null) {
                        innerCloseBtn.addEventListener('click', this.toggleMap.bind(this));
                    }
                });
            }.bind(this))
        }
        else {
            this.overlay.close();
        }
    }
    
    loadMap(successCallback) {
        window.getMapXHR = new XMLHttpRequest();

        const url = "LoadMapMarkers";
        getMapXHR.onreadystatechange = function () {
            if (this.readyState !== 4) return;
            if (this.status !== 200) {
                console.log('Error fetching map');
                // Error
                return;
            }
            // Success
            successCallback(this.responseText);
        };

        getMapXHR.open('POST', url, true);
        getMapXHR.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        getMapXHR.send();
    }
}

loader.add('MapOverlay', MapOverlay);

export default MapOverlay;
